import { connect, ConnectedProps } from 'react-redux';
import { BillingOption } from '../../../../../../../../shared/utils/billing-options';
import { RootState } from '../../../../../../../../store/root-reducer';
import PlansSection from './plans-section';

const mapStateToProps = (state: RootState) => ({
  sendGetDialerSubscriptionResponse:
    state.billingAndSubscription.getDialerSubscriptionResponse,
  sendGetDialerPlansResponse:
    state.billingAndSubscription.getDialerPlansResponse,
  sendGetPurchaseDialerModifySubscriptionRequestStatus:
    state.billingAndSubscription.purchaseDialerModifySubscriptionRequest.status,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  onSelectPlan: (planId: number, planName: string) => void;
  planCycle: BillingOption;
  selectedPlanId: number;
  isPaddlePolling?: boolean;
};

export default connector(PlansSection);
